<template>
  <div class="domT">
    <div style="color: #1989fa">
      上传最新健康码截图
    </div>
    <div class="domT-body">
      <div class="btn-add">
        <van-uploader id="file" v-model="fileList" multiple :max-count="1" :max-size="1024 * 1024" @oversize="onOversize"
                    :before-read="beforeRead" :after-read="afterRead"/>
      </div>
    </div>
  </div>

</template>

<script>
  import {Uploader} from 'vant'
  import {Toast} from 'vant'
  import Compressor from 'compressorjs'

  export default {
    name: 'HealthCode',
    data () {
      return {
        fileList: [],
        HContent: ''
      }
    },
    mounted () {
    },
    methods: {
      onOversize (file) {
        Toast('文件大小不能超过 1M')
      },
      beforeRead(file){
        if (file.type !== 'image/jpeg') {
          Toast('请上传 jpg 格式图片');
          return false;
        }
        return true;
      },
      getBase64 (file) {
        var _this=this
        return new Promise((resolve, reject) => {
          let reader = new FileReader()
          let fileResult = ''
          reader.readAsDataURL(file)
          reader.onload = function () {
            fileResult = reader.result
            _this.$emit('HContent', reader.result)
            // console.log(fileResult)
          }

          reader.onerror = function (error) {
            reject(error)
          }
          reader.onloadend = function () {
            resolve(fileResult)
          }
        })
      },
      afterRead (file) {
        // console.log(file)
        var _this=this
        const fil = file.file
        if (!file) {
          return
        }
        //压缩图片
        new Compressor(fil, {
          quality: 0.3,
          success (result) {
            //压缩有转base64
            _this.getBase64 (result)

            // const formData = new FormData()
            //
            // // The third parameter is required for server
            // formData.append('file', result, result.name)
            // console.log(formData)
          },
          error (err) {
            console.log(err.message)
          },
        })
        // this.HContent = file.content
        // console.log(this.HContent)
        // this.$emit('HContent', file.content)
      },
    }
  }
</script>

<style scoped>
  /*.btn-add {*/
  /*  background-color: #07c160;*/
  /*  color: #fff;*/
  /*  padding: 0 10px;*/
  /*  font-size: 14px;*/
  /*  height: 40px;*/
  /*  line-height: 2.8;*/
  /*  text-align: center;*/
  /*  border-radius: 2px;*/
  /*  cursor: pointer;*/
  /*  transition: opacity .2s;*/
  /*  -webkit-appearance: none;*/
  /*  width: 100px;*/
  /*  display: inline-block;*/
  /*}*/

  .btn-add {
    text-align: center;
  }

  .domT-body {
    border: #c8c9cc 1px solid;
    margin: 0 10px;
    padding: 10px;
    font-size: 0.8em;
    border-radius: 5px;
  }

  .list-info {
    border-bottom: #c8c9cc 1px solid;
    margin-bottom: 5px;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/HealthCode.vue